import { Button, FormField, Select } from '@/shared/components';
import type { ChannelCloseoutOptions } from '@/shared/api';
import { apartmentName } from './channelCloseoutDraft';

/** MinStay schreibt die Kanalsteuerung nicht selbst; sie führt in den Grundkalender. */
export function ChannelCloseoutMinStayLink({
  propertyIds,
  apartments,
  selected,
  onSelect,
  onOpen,
}: {
  propertyIds: string[];
  apartments: ChannelCloseoutOptions['apartments'];
  selected: string;
  onSelect: (propertyId: string) => void;
  onOpen: () => void;
}) {
  return (
    <div className="border-hairline flex flex-wrap items-end gap-3 border-t pt-4">
      <FormField label="MinStay getrennt für Apartment setzen" className="min-w-56 flex-1">
        <Select value={selected} onChange={(event) => onSelect(event.target.value)}>
          {propertyIds.map((id) => (
            <option key={id} value={id}>
              {apartmentName(apartments, id)}
            </option>
          ))}
        </Select>
      </FormField>
      <Button type="button" variant="ghost" disabled={!selected} onClick={onOpen}>
        Im Grundkalender öffnen
      </Button>
    </div>
  );
}
